import React from "react";
import "./styles.css";

// Контейнер поля формы: единый ритм и ширина для label + control.
export default function InputWrapper({ className = '', children }) {
    return <div className={`input__wrapper ${className}`}>{children}</div>;
}
